import { useState, useEffect, useContext } from "react";
import { MasajidContext } from "../contexts/MasajidContext";
import { Share2, Check } from "lucide-react";

function ShareButton({ masjidDetails }) {
  const [copied, setCopied] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { language } = useContext(MasajidContext);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleShare = async () => {
    const shareData = {
      title:
        language === "urdu"
          ? `\u200Fمساجد MIS - ${masjidDetails.urdName}`
          : `${masjidDetails.engName} - MIS Masajid`,
      text:
        language === "urdu"
          ? `\u200F${masjidDetails.urdName} کی تفصیلات دیکھیں\n\n`
          : `Check out the details for ${masjidDetails.engName}\n\n`,
      url: window.location.href,
    };

    // Check if Web Share API is supported
    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Error sharing:", err);
          fallbackCopyToClipboard();
        }
      }
    } else {
      fallbackCopyToClipboard();
    }
  };

  const fallbackCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const showText = !isMobile;

  return (
    <button
      onClick={handleShare}
      style={{
        background: "rgba(27, 179, 200, 0.1)",
        border: "3px solid #1bb3c8",
        borderRadius: "24px",
        padding: isMobile ? "10px 12px" : "12px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        cursor: "pointer",
        transition: "all 0.3s ease",
        fontSize: "16px",
        fontWeight: "600",
        color: "rgb(255, 255, 255, 0.9)",
        width: "100%",
        boxSizing: "border-box",
      }}
      aria-label="Share masjid details"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: showText ? "6px" : "0",
          minWidth: showText ? "100px" : "auto",
        }}
      >
        {copied ? (
          <>
            <Check size={20} color="#1bb3c8" style={{ flexShrink: 0 }} />
            {showText && (
              <span
                style={{ whiteSpace: "nowrap" }}
                lang={language === "urdu" && "ur"}
                dir={language === "urdu" ? "rtl" : "ltr"}
              >
                {language === "urdu" ? "لنک کاپی ہوگیا ہے!" : "Copied!"}
              </span>
            )}
          </>
        ) : (
          <>
            <Share2 size={20} color="#1bb3c8" style={{ flexShrink: 0 }} />
            {showText && (
              <span
                style={{ whiteSpace: "nowrap" }}
                lang={language === "urdu" && "ur"}
              >
                {language === "urdu" ? "شیئر کریں" : "Share"}
              </span>
            )}
          </>
        )}
      </div>
    </button>
  );
}

export default ShareButton;
